<template>
  <div v-if="courses" class="disposer-courses">
    <eventNav />
    <div class="disposer-app-title">
      E-Learning
      <label class="disposer-app-title--checkbox">
        <input
          v-model="isCheckActiveDashdord"
          :class="{ active: isCheckActiveDashdord }"
          type="checkbox"
          @click="activeDashbord"
        />
      </label>
      <span class="title-info">Display on the dashboard</span>
    </div>
    <app-section
      v-for="(section, index) in courses.sections"
      :key="section.id"
      :save="() => saveSection(section)"
      :delete-handler="() => deleteSection(section)"
      delete-warning="Are you sure to delete section?"
    >
      <h3>Section {{ index + 1 }}</h3>
      <br />

      <div class="inputs">
        <app-input v-model="section.title" title="Title" />

        <label class="disposer-app-label flex align-center mt-1">
          <span>Collapsed</span>
          <label class="disposer-app-title--checkbox">
            <input v-model="section.collapsed" :class="{ active: section.collapsed }" type="checkbox" />
          </label>
        </label>

        <label class="disposer-app-label">
          Order
          <div class="disposer-app-label--order">
            <vue-numeric-input v-model="section.number" :min="1" controls-type="updown" />
          </div>
        </label>
      </div>

      <div v-for="(course, courseIndex) in section.courses" :key="course.id" class="course mt-1 mr-1">
        <div class="inputs">
          <h3 class="mb-1">Course {{ courseIndex + 1 }}</h3>
          <app-input v-model="course.title" title="Title" />

          <app-editor v-model="course.description" title="Description" />

          <label class="disposer-app-label mt-1">
            Preview
            <div class="flex align-center mt-1">
              <app-file-input accept="image/*" class="mr-1" :load-file="event => loadPicture(event, course)">
                Choose
              </app-file-input>
              <a v-if="course.previewSrc" :href="course.previewSrc" target="_blank">
                {{ course.previewFile.name }}
              </a>
              <a v-else-if="course.preview" target="_blank" :href="generateFileUrl(course.preview)">
                preview file
              </a>
            </div>
          </label>

          <label class="disposer-app-label mt-1">
            Course files (.zip)
            <div class="flex align-center mt-1">
              <app-file-input accept=".zip" :load-file="event => loadZip(event, course)">
                Choose
              </app-file-input>

              <span v-if="course.file" class="ml-1">{{ course.file.name }}</span>
              <a v-else-if="course.entrypoint" target="_blank" :href="generateUrl(course.entrypoint)" class="ml-1">
                course source
              </a>
            </div>
          </label>
        </div>
        <div>
          <app-button class="mini red" @click="saveCourse(course, section.id)">
            Save
          </app-button>
          <app-button class="mini mt-1" @click="deleteCourse(course, section.id)">
            Delete
          </app-button>
        </div>
      </div>
      <app-button v-if="section.id" class="mt-1" @click="addCourse(section)">
        Add course
      </app-button>
    </app-section>
    <app-button @click="addSection">
      Add section
    </app-button>
  </div>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';
import { generateFileUrl } from '@/utils/http-helper';
import generateUrl from '@/utils/mixins/generate_url';
import eventNav from '@/components/disposer/pages/event/event-nav.vue';
import appSection from '@/components/disposer/app/app-section';
import appButton from '@/components/disposer/app/app-button';
import appInput from '@/components/disposer/app/app-input';
import appEditor from '@/components/disposer/app/app-editor';
import appFileInput from '@/components/disposer/app/app-file-input';
import { parseImg } from '@/utils/disposer/parse-files-helper';
import { post } from '@/utils/http-helper';

export default {
  name: 'disposer-courses',
  components: {
    eventNav,
    appSection,
    appButton,
    appInput,
    VueNumericInput,
    appEditor,
    appFileInput,
  },
  mixins: [generateUrl],
  computed: {
    eventId() {
      return this.$route.params.id;
    },

    courses() {
      return this.$store.getters['disposerCourses/get'];
    },
  },
  data() {
    return {
      isCheckActiveDashdord: false,
    };
  },
  async created() {
    await this.loadCourses();

    if (this.courses?.display_dash === 3) {
      this.isCheckActiveDashdord = true;
    } else {
      this.isCheckActiveDashdord = false;
    }
  },
  methods: {
    generateFileUrl(file) {
      return generateFileUrl(file);
    },
    async saveSection(section) {
      await this.$store.dispatch('disposerCourses/saveSection', {
        event_id: this.eventId,
        section_id: section.id,
        title: section.title,
        number: section.number,
        collapsed: section.collapsed,
      });
    },
    async deleteSection(section) {
      await this.$store.dispatch('disposerCourses/deleteSection', {
        event_id: this.eventId,
        section_id: section.id,
      });
    },
    addSection() {
      this.$store.dispatch('disposerCourses/addSection', {
        event_id: this.eventId,
        id: 0,
        title: null,
        collapsed: false,
        number: null,
      });
    },
    addCourse(section) {
      this.$store.dispatch('disposerCourses/addCourse', {
        id: 0,
        section_id: section.id,
        preview: null,
        previewFile: null,
        previewSrc: null,
        file: null,
      });
    },
    async loadPicture(img, course) {
      course.previewFile = img;
      course.previewSrc = await parseImg(img);
    },
    async loadZip(zip, course) {
      course.file = zip;
    },
    async saveCourse(course, section_id) {
      await this.$store.dispatch('disposerCourses/saveCourse', {
        event_id: this.eventId,
        section_id: section_id,
        id: course.id,
        title: course.title,
        description: course.description,
        previewFile: course.previewFile,
        file: course.file,
      });
    },
    async deleteCourse(course) {
      await this.$store.dispatch('disposerCourses/deleteCourse', {
        event_id: this.eventId,
        id: course.id,
      });
    },
    async loadCourses() {
      await this.$store.dispatch('disposerCourses/get', this.eventId);
    },

    activeDashbord() {
      this.$awn.async(
        post('/event/change-display-dash', {
          event_id: this.eventId,
          status: this.isCheckActiveDashdord ? 0 : 3,
        }),
      );
    },
  },
};
</script>

<style scoped lang="scss">
.disposer-courses {
  .inputs {
    width: to_rem(740px);
    overflow: hidden;
  }

  .course {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    padding: 1.25rem;

    background-color: #f0f0f0;
  }
  .title-info {
    font-size: 17px;
    color: #7f7f7f;
    padding-left: 12px;
  }
}
</style>
